import { render } from "./FormViewSubmissions.vue?vue&type=template&id=1a2cb422&ts=true"
import script from "./FormViewSubmissions.vue?vue&type=script&lang=ts"
export * from "./FormViewSubmissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__